import { useEffect } from 'react'

// todo: 写成service
export const useSetInterval = (
  callback: () => boolean | Promise<boolean> | void,
  delay: number,
  trigger?: boolean,
  dep: any[] = [],
) => {
  useEffect(() => {
    let timerId: NodeJS.Timeout | null = null
    if (trigger) {
      timerId = setInterval(async () => {
        const stop = await callback()
        if (!!stop) {
          timerId && clearInterval(timerId)
        }
      }, delay)
      return () => {
        timerId && clearInterval(timerId)
      }
    } else {
      timerId && clearInterval(timerId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [trigger, ...dep])
}
